import { Facet, NumericRangeValue } from './Types'
import { RangeSlider } from 'components/forms'

interface NumericRangeFacetProps {
  facet: Facet<NumericRangeValue>
  onChange: (selectedOptions: { from: number; to: number } | {}) => void
}

export const NumericRangeFacet = ({
  facet,
  onChange,
}: NumericRangeFacetProps) => {
  const { min, max } = facet.values as NumericRangeValue
  const optionDiff = max - min

  const handleChange = (selectedOptions: { from: number; to: number }) => {
    onChange(selectedOptions)
  }

  const minValue = min === max ? 0 : min

  return (
    <div className="mal mtxl ptm">
      <RangeSlider
        labelPrefix="$"
        minOption={Math.ceil(minValue)}
        maxOption={Math.floor(max)}
        minValue={Math.ceil(minValue)}
        maxValue={Math.floor(max)}
        step={optionDiff < 20 ? 1 : 10}
        onChange={handleChange}
      />
    </div>
  )
}
